<template>
    <i class="ico-svg-bookmark">
        <svg v-bind="{ width, height }" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 20l-8-5-8 5V2.5C0 1.12 1.075 0 2.4 0h11.2C14.925 0 16 1.12 16 2.5V20z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconBookmark',

    props: {
        width: {
            type: Number,
            default: 16,
        },

        height: {
            type: Number,
            default: 20,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
